import { Stack, Tab, Tabs, Typography } from '@mui/material';
import { Link, Outlet, useLocation } from 'react-router';

export interface PageTab {
  to: string;
  label: string;
}

/** A page with sub tabs, each its own address, so a tab can be linked to and survives a reload. */
export function TabbedLayout({
  title,
  label,
  tabs,
}: {
  title: string;
  label: string;
  tabs: PageTab[];
}) {
  const { pathname } = useLocation();
  // The first tab's address is a prefix of the others, so match the longest.
  const current =
    tabs
      .filter((tab) => pathname === tab.to || pathname.startsWith(`${tab.to}/`))
      .sort((a, b) => b.to.length - a.to.length)[0] ?? tabs[0];
  return (
    <Stack spacing={3}>
      <div>
        <Typography variant="h5" gutterBottom>
          {title}
        </Typography>
        <Tabs
          value={current.to}
          aria-label={label}
          sx={{ borderBottom: 1, borderColor: 'divider' }}
        >
          {tabs.map((tab) => (
            <Tab key={tab.to} value={tab.to} label={tab.label} component={Link} to={tab.to} />
          ))}
        </Tabs>
      </div>
      <Outlet />
    </Stack>
  );
}
